import AsyncStorage from '@react-native-async-storage/async-storage';

const ONBOARDING_IN_PROGRESS_KEY = 'onboarding_in_progress';

export class OnboardingStateService {
  static async setOnboardingInProgress(inProgress: boolean): Promise<void> {
    try {
      if (inProgress) {
        await AsyncStorage.setItem(ONBOARDING_IN_PROGRESS_KEY, 'true');
        console.log('✅ Onboarding in progress flag SET');
      } else {
        await AsyncStorage.removeItem(ONBOARDING_IN_PROGRESS_KEY);
        console.log('✅ Onboarding in progress flag CLEARED');
      }
    } catch (error) {
      console.error('❌ Error setting onboarding progress flag:', error);
    }
  }

  static async isOnboardingInProgress(): Promise<boolean> {
    try {
      const value = await AsyncStorage.getItem(ONBOARDING_IN_PROGRESS_KEY);
      const inProgress = value === 'true';
      console.log(`🔍 Onboarding in progress check: ${inProgress}`);
      return inProgress;
    } catch (error) {
      console.error('❌ Error checking onboarding progress:', error);
      return false;
    }
  }

  static async clearOnboardingState(): Promise<void> {
    try {
      await AsyncStorage.removeItem(ONBOARDING_IN_PROGRESS_KEY);
      console.log('✅ Onboarding state cleared');
    } catch (error) {
      console.error('❌ Error clearing onboarding state:', error);
    }
  }
}
